module.exports = __webpack_public_path__ + "media/images/Bonita-a2427be5bf5630780ac10b0914d345fd.png";